import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  HowItWorksIcon,
  BuyingIcon,
  SellingIcon,
  AuthenticationIcon,
  NewsIcon,
  CompanyIcon,
} from '@stockx/icons';

import { PageSwitcherTypes } from '@app/router';
import useUrlPrefix from '@app/hooks/useUrlPrefix';
import { MenuItem } from '../../shared/types/menu';

type useAboutMenuReturn = {
  items: MenuItem[];
};

const iconStyles = { marginRight: 4, boxSize: 7 };

const useAboutMenu = (): useAboutMenuReturn => {
  const { t } = useTranslation();
  const urlPrefix = useUrlPrefix();

  const items = useMemo(
    () => [
      {
        title: t('about_how_it_works_title'),
        path: `https://stockx.com/about${urlPrefix}how-it-works`,
        icon: <HowItWorksIcon {...iconStyles} />,
        description: t('about_how_it_works_description'),
        eventLabel: 'How It Works',
        linkType: PageSwitcherTypes.External,
      },
      {
        title: t('about_buying_title'),
        path: `https://stockx.com/about${urlPrefix}buying`,
        icon: <BuyingIcon {...iconStyles} />,
        description: t('about_buying_description'),
        eventLabel: 'Buying Guide',
        linkType: PageSwitcherTypes.External,
      },
      {
        title: t('about_selling_title'),
        path: `https://stockx.com/about${urlPrefix}selling`,
        icon: <SellingIcon {...iconStyles} />,
        description: t('about_selling_description'),
        eventLabel: 'Selling Guide',
        linkType: PageSwitcherTypes.External,
      },
      {
        title: t('about_authentication_title'),
        path: `https://stockx.com/about${urlPrefix}verification`,
        icon: <AuthenticationIcon {...iconStyles} />,
        description: t('about_authentication_description'),
        eventLabel: 'Authentication',
        linkType: PageSwitcherTypes.External,
      },
      {
        title: t('about_newsroom_title'),
        path: `https://stockx.com/about${urlPrefix}newsroom`,
        icon: <NewsIcon {...iconStyles} />,
        description: t('about_newsroom_description'),
        eventLabel: 'Newsroom',
        linkType: PageSwitcherTypes.External,
      },
      {
        title: t('about_company_title'),
        path: `https://stockx.com/about${urlPrefix}company`,
        icon: <CompanyIcon {...iconStyles} />,
        description: t('about_company_description'),
        eventLabel: 'Company',
        linkType: PageSwitcherTypes.External,
      },
    ],
    [t, urlPrefix],
  );

  return { items };
};

export default useAboutMenu;
